module.exports = __webpack_public_path__ + "static/agemar-422bf9051579752cad0d0bde13fb20e5.png";